export default __webpack_public_path__ + "static/media/sticker2.faff6a43.png";